import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicContentSchemaFacade, DynamicContentSchemaFactory } from '../../akita';

@Injectable({ providedIn: 'root' })
export class ContentInternalService {

  dynamicContentSchemaFacade: DynamicContentSchemaFacade;

  constructor(
      private dynamicContentSchemaFactory: DynamicContentSchemaFactory,
      private router: Router) {
  }


  cloneContent(contentId: string, schemaName: string) {
    this.dynamicContentSchemaFacade = this.dynamicContentSchemaFactory.getDynamicContentSchemaFacade(schemaName);

    this.dynamicContentSchemaFacade.get(contentId, true).subscribe(content => {
      localStorage.setItem("cloneData-" + schemaName, JSON.stringify(content.data));
      this.router.navigate(['/contents/' + schemaName]);
    });
  }

}
